import { Button, Modal, ModalBody, ModalFooter, ModalHeader, Input, Form, FormText } from 'reactstrap';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { actions } from '../../context';

const SyncConfirmationModal = (props) => {
    const { type, isOpen, closeModal, practiceId } = props;
    const [message, setMessage] = useState('');
    const dispatch = useDispatch();

    const submit = async (e) => {
        e.preventDefault(); //prevent actual form submission from reloading the page

        if (IsType(type, AgentRestart)) {
            doAgentRestart(practiceId, message, dispatch);
        }

        if (IsType(type, StartDataExtraction)) {
            doDataExtraction(practiceId, message, dispatch);
        }

        if (IsType(type, TerminateDataExtraction)) {
            doTerminateDataExtraction(practiceId, message, dispatch);
        }

        if (IsType(type, TerminateAttachmentSync)) {
            doTerminateAttachmentSync(practiceId, message, dispatch);
        }

        if (IsType(type, StagingLoad)) {
            doStagingLoad(practiceId, message, dispatch);
        }
        
        if (IsType(type, IntermediateLoad)) {
            doIntermediateLoad(practiceId, message, dispatch);
        }

        if (IsType(type, DaylightSync)) {
            doDaylightSync(practiceId, message, dispatch);
        }

        if (IsType(type, DaylightCodeConversion)) {
            doDaylightCodeConversion(practiceId, dispatch);
        }

        if (IsType(type, ReportingSync)) {
            doReportingSync(practiceId, message, dispatch);
        }

        if (IsType(type, LeadsGeneration)) {
            doLeadsGeneration(practiceId, message, dispatch);
        }
        
        resetForm();
        closeModalIntercept(closeModal);
    };

    const resetForm = () => {
        setMessage('');
    }

    const closeModalIntercept = (closeModal) => {
        resetForm();
        closeModal();
    }

    return (
        <Modal isOpen={isOpen} centered className="text-light" toggle={() => closeModalIntercept(closeModal)} autoFocus={false}>
            <Form onSubmit={submit}>
                <ModalHeader>Confirm {type}</ModalHeader>
                <ModalBody>
                    <Input autoFocus={true} value={message} onChange={e => setMessage(e.target.value)} type='textarea' placeholder={`Please include a reason for this ${type.toLowerCase()}`}></Input>
                    <FormText></FormText>
                </ModalBody>
                <ModalFooter>
                    <Button color='primary' onClick={resetForm}>Reset</Button>
                    <Button type='submit' color='success'>Submit</Button>
                </ModalFooter>
            </Form>
        </Modal>
    );
};

const IsType = (input, checkType) => {
    let lowered = input.toLowerCase();
    
    return lowered.includes(checkType);
}

const doAgentRestart = (practiceId, message, dispatch) => {
    dispatch(actions.practice.triggerAgentRestart(practiceId, message))
        .then(() => dispatch(actions.notes.fetchNotes(practiceId)));
}

const doDataExtraction = (practiceId, message, dispatch) => {
    dispatch(actions.practice.triggerManualPracticeExtraction(practiceId, message))
        .then(() => dispatch(actions.notes.fetchNotes(practiceId)));
}

const doTerminateDataExtraction = (practiceId, message, dispatch) => {
    dispatch(actions.practice.terminateDataExtraction(practiceId, message))  
        .then(() => dispatch(actions.notes.fetchNotes(practiceId)));
}

const doTerminateAttachmentSync = (practiceId, message, dispatch) => {
    dispatch(actions.practice.terminateAttachmentSync(practiceId, message))
        .then(() => dispatch(actions.notes.fetchNotes(practiceId)));
}

const doStagingLoad = (practiceId, message, dispatch) => {
    dispatch(actions.practice.triggerManualPracticeStagingLoad(practiceId, message))
        .then(() => dispatch(actions.notes.fetchNotes(practiceId)));
}

const doIntermediateLoad = (practiceId, message, dispatch) => {
    dispatch(actions.practice.triggerManualPracticeIntermediateLoad(practiceId,message))
        .then(() => dispatch(actions.notes.fetchNotes(practiceId)));
}

const doDaylightSync = (practiceId, message, dispatch) => {
    dispatch(actions.practice.triggerManualPracticeDaylightSync(practiceId,message))
        .then(() => dispatch(actions.notes.fetchNotes(practiceId)));
}

const doDaylightCodeConversion = (practiceId, dispatch) => {
    dispatch(actions.daylight.runCodeConverter(practiceId));
}

const doReportingSync = (practiceId, message, dispatch) => {
    dispatch(actions.practice.triggerManualPracticeReportingSync(practiceId, message));
}

const doLeadsGeneration = (practiceId, message, dispatch) => {
    dispatch(actions.practice.triggerManualPracticeLeadsGeneration(practiceId, message))
        .then(() => dispatch(actions.notes.fetchNotes(practiceId)));
}

const AgentRestart = 'restart';
const StartDataExtraction = 'start data extraction';
const TerminateDataExtraction = 'terminate data extraction';
const TerminateAttachmentSync = 'terminate attachment sync';
const StagingLoad = 'staging';
const IntermediateLoad = 'intermediate';
const DaylightSync = 'daylight sync';
const DaylightCodeConversion = 'daylight code conversion';
const ReportingSync = 'reporting sync';
const LeadsGeneration = 'leads generation';

export default SyncConfirmationModal;
